import React, { FunctionComponent } from 'react';
import { InjectedIntl } from 'react-intl';
import { Link } from '@nbc-design/link';

import { DocumentItem } from '../types';

export type StaticDocumentLink = {
  id: string;
  label: string;
  url: string;
};

export type DocumentLinkListProps = {
  intl: InjectedIntl;
  documents?: DocumentItem[];
  documentsURLs?: string[];
  staticLinks?: StaticDocumentLink[];
};

const DocumentLinkList: FunctionComponent<DocumentLinkListProps> = ({
  intl,
  documents = [],
  documentsURLs = [],
  staticLinks,
}) => {
  if (staticLinks) {
    return (
      <div className="document-link-list" data-test="document_link_list">
        {staticLinks.map(({ id, label, url }) => (
          <div key={`document-link-${id}`} className="document-link-item">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-test={`document_link_${id}`}
              className="document-link-text-item"
            >
              {label}
            </a>
          </div>
        ))}
      </div>
    );
  }

  if (!documents.length) {
    return null;
  }

  return (
    <div className="document-link-list" data-test="document_link_list">
      {documents.map((doc, i) => {
        const title = doc.title[intl.locale];
        const documentId = doc.documentId[intl.locale];
        const file = documentsURLs[i];
        return (
          <div key={`document-link-${documentId}`} className="document-link-item">
            <Link
              href={file}
              target="_blank"
              rel="noopener noreferrer"
              dataTest={`document_link_${documentId}`}
              className="document-link-text-item"
            >
              {title}
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default DocumentLinkList;
